import { Base } from './_base';
import transform from 'lodash-es/transform';
import toArray from 'lodash-es/toArray';
import { merge_by_template } from '@shared/helpers/collections';

export class QueueFrontend extends Base {
  constructor(item) {
    super(item);

    this.data = merge_by_template(this.data, {
      params: {
        type: 'all',
        freeze: false,
        timeout: 180,
        contact_groups: [],
        contact_methods: []
      },
      options: {
        next: null,
        timeout: null
      }
    });

    this.data.params = transform(this.data.params, (result, value, key) => {
      if (['contact_groups', 'contact_methods'].includes(key)) {
        result[key] = toArray(value);
        return;
      }
      result[key] = value;
    });
  }
}
